/* Mastichová kalkulačka v2 – doporučovací engine.
 * Čistá logika bez DOM: vstupem je konfigurace (metapole shopu custom.kalkulacka z aplikace), katalog (z metafieldů produktů
 * katalogové kolekce, sestavuje Liquid sekce) a odpovědi; výstupem strukturované doporučení.
 *
 * Tvar katalogu:
 * {
 *   rady: { strong_pure: { klic, nazev, jednotka, popis, davkovaniText, mgMasticha|null,
 *                          vychoziDavka|null (běžná dávka, jednotek/den), slozeni:[řádky] }, ... },
 *   baleni: [ { id, sku, rada, jednotek|null, polozky:[{rada,jednotek,denne?,denne_intenzivni?}]|null, vydrzFixni|null,
 *               nazev, url, obrazek, variantId, cena (minor units), dostupne (bool) }, ... ]
 * }
 *
 * Konec stromu s produkty (rozhodnutí 43): { konec: true, produkty: [{ sku, davka }], dni: null | N }
 * nabídne konkrétní balení v pořadí z aplikace; denní dávka je u produktu, dni = délka kúry
 * (null = průběžně). Výdrž, počet balení na kúru a cenu za den počítá engine (konecSProdukty).
 * Konec s řadou { rada, alt, intenzita } (rozhodnutí 41) dál vybírá balení podle řady.
 */
(function (root) {
  "use strict";

  /* ---------- Vyhodnocování podmínek ----------
   * Obecně podle ID kroku (balíček 38): `p` = id kroku, `in` = odpověď kroku je jedna z hodnot
   * (u kroku s víc odpověďmi stačí jedna), `maNektery` = mezi odpověďmi je aspoň jedna z hodnot.
   * Zvláštní je jen `cilNeboExtra` (hlavní cíl nebo zaškrtnuté „navíc“). Nový krok z aplikace
   * tak jde použít v pravidle i výhradě bez změny enginu. */
  function hodnotyOdpovedi(h) {
    if (Array.isArray(h)) return h;
    return h === undefined || h === null ? [] : [h];
  }
  function splnenaPodminka(c, a) {
    if (c.p === "cilNeboExtra") return a.goal === c.v || (a.extra || []).indexOf(c.v) !== -1;
    var h = a[c.p];
    if (c.in) {
      if (Array.isArray(h)) return h.some(function (v) { return c.in.indexOf(v) !== -1; });
      return c.in.indexOf(h) !== -1;
    }
    if (c.maNektery) {
      var odp = hodnotyOdpovedi(h);
      return c.maNektery.some(function (v) { return odp.indexOf(v) !== -1; });
    }
    return false;
  }
  function splneno(kdyz, a) { return (kdyz || []).every(function (c) { return splnenaPodminka(c, a); }); }

  /* Aktuální hodnota odpovědi, kterou podmínka testuje – jen pro debug trace. */
  function aktualniHodnota(c, a) {
    if (c.p === "cilNeboExtra") return [a.goal].concat(a.extra || []);
    var h = a[c.p];
    return Array.isArray(h) ? h : (h === undefined ? undefined : h);
  }

  /* ---------- Strom (rozhodnutí 41) ----------
   * config.strom = { koren, uzly: { id: { klic, odpovedi: [{ v, ic, dalsi }] } | { konec: true, rada, alt, intenzita } } }.
   * Uzel s otázkou má vlastní odpovědi a texty (uzly.<id>.… v I18N); odpověď se ukládá pod `klic`
   * (na jedné cestě nejvýš jednou) a vede na další uzel; konec nese doporučení. Starý tvar uzlu
   * { otazka, dalsi: { volba: id } } se ptá kroku `otazka`. Bez stromu platí kroky se zobrazKdyz a pravidla. */
  function krokPodleId(config, id) {
    for (var i = 0; i < config.kroky.length; i++) if (config.kroky[i].id === id) return config.kroky[i];
    return null;
  }
  function odpovediUzlu(u) {
    if (u.odpovedi) return u.odpovedi;
    return Object.keys(u.dalsi || {}).map(function (v) { return { v: v, dalsi: u.dalsi[v] }; });
  }
  function klicUzlu(u) { return u.klic || u.otazka; }
  function dalsiUzel(u, h) {
    var o = odpovediUzlu(u).filter(function (x) { return x.v === h; })[0];
    return o ? o.dalsi : null;
  }
  /* Uzel jako krok wizardu: vlastní odpovědi (uzel = id uzlu pro texty), starý tvar = krok otázky. */
  function krokUzlu(config, u) {
    if (!u.odpovedi) return krokPodleId(config, u.otazka);
    return { id: u.klic, uzel: u.id, typ: "single", povinny: true, volby: u.odpovedi.map(function (o) { return { v: o.v, ic: o.ic || "" }; }) };
  }
  /* Cesta stromem podle odpovědí: { uzly: [uzel s otázkou…], konec: uzel | null }. Končí na prvním
   * uzlu bez odpovědi (ten je v `uzly` poslední), na konci, nebo na volbě bez pokračování. */
  function cestaStromem(config, a) {
    var s = config.strom, out = { uzly: [], konec: null };
    var id = s.koren, pojistka = 0;
    while (id && s.uzly[id] && pojistka++ < 100) {
      var u = s.uzly[id];
      if (u.konec) { out.konec = Object.assign({ id: id }, u); break; }
      out.uzly.push(Object.assign({ id: id }, u));
      var h = a[klicUzlu(u)];
      if (h === undefined || h === null) break;
      id = dalsiUzel(u, h);
    }
    return out;
  }
  /* Počet otázek na nejdelší cestě z uzlu do konce. */
  function hloubka(config, id) {
    var u = config.strom.uzly[id];
    if (!u || u.konec) return 0;
    var max = 0;
    odpovediUzlu(u).forEach(function (o) { var h = o.dalsi ? hloubka(config, o.dalsi) : 0; if (h > max) max = h; });
    return 1 + max;
  }

  /* ---------- Kroky ---------- */
  function aktivniKroky(config, a) {
    if (config.strom) {
      return cestaStromem(config, a).uzly.map(function (u) { return krokUzlu(config, u); }).filter(Boolean);
    }
    return config.kroky.filter(function (k) { return !k.zobrazKdyz || splneno(k.zobrazKdyz, a); });
  }
  /* Celkový počet kroků pro „Krok x / N“: u stromu zodpovězené otázky + nejdelší zbytek cesty. */
  function celkemKroku(config, a) {
    if (!config.strom) return aktivniKroky(config, a).length;
    var c = cestaStromem(config, a);
    if (c.konec || !c.uzly.length) return c.uzly.length;
    var posledni = c.uzly[c.uzly.length - 1];
    return c.uzly.length - 1 + hloubka(config, posledni.id);
  }
  function aktivniVolby(krok) {
    return krok.volby.filter(function (v) { return v.aktivni !== false; });
  }

  /* ---------- Výchozí/resetovaná hodnota kroku a state ----------
   * Jedno místo pravdy pro výchozí state: typ "multi" → [], typ "single" → krok.vychozi
   * (definováno u kroku v mlk-config.js, viz komentář nad `kroky`). Používá ho jak
   * vychoziOdpovedi() (počáteční state formuláře), tak sanitizujOdpovedi() (reset kroku,
   * který přestal být aktivní).
   */
  function vychoziKroku(krok) {
    if (krok.typ === "multi") return [];
    return krok.vychozi !== undefined ? krok.vychozi : null;
  }

  function vychoziOdpovedi(config) {
    var a = {};
    (config.kroky || []).forEach(function (k) { a[k.id] = vychoziKroku(k); });
    return a;
  }

  /* Sanitace state: odpovědi krokům, které už nejsou aktivní (zobrazKdyz nesplněno),
   * se resetují na výchozí hodnotu kroku. Nemutuje vstup. Aktivita kroku se počítá
   * z (částečně) sanitovaných odpovědí, proto iterujeme do stabilního stavu – ohraničeně
   * na počet kroků, aby to nemohlo zacyklit ani při budoucích řetězených závislostech.
   */
  function sanitizujOdpovedi(config, answers) {
    var a = {};
    Object.keys(answers || {}).forEach(function (k) {
      var v = answers[k];
      a[k] = Array.isArray(v) ? v.slice() : v;
    });
    /* Strom: platí jen odpovědi uzlů na cestě (odpověď mimo cestu by po návratu přeskočila otázku). */
    if (config.strom && config.strom.uzly[config.strom.koren] && config.strom.uzly[config.strom.koren].odpovedi) {
      var naCeste = {};
      cestaStromem(config, a).uzly.forEach(function (u) { var k = klicUzlu(u); if (a[k] !== undefined && a[k] !== null && dalsiUzel(u, a[k]) !== null) naCeste[k] = a[k]; });
      return naCeste;
    }
    var kroky = config.kroky || [];
    var maxIter = kroky.length + 1;
    for (var iter = 0; iter < maxIter; iter++) {
      var aktivniIds = {};
      aktivniKroky(config, a).forEach(function (k) { aktivniIds[k.id] = true; });
      var zmeneno = false;
      kroky.forEach(function (k) {
        if (aktivniIds[k.id]) return;
        var def = vychoziKroku(k);
        var current = a[k.id];
        var jeVychozi = Array.isArray(def)
          ? (Array.isArray(current) && current.length === 0)
          : (current === def);
        if (!jeVychozi) { a[k.id] = def; zmeneno = true; }
      });
      if (!zmeneno) break;
    }
    return a;
  }

  /* ---------- Cíl ze symptomů (větev „nevím") ---------- */
  function cilZeSymptomu(config, symptoms) {
    var score = {};
    (symptoms || []).forEach(function (s) {
      var cil = config.symptomyNaCil[s];
      if (cil) score[cil] = (score[cil] || 0) + 1;
    });
    var best = config.vychoziCil, max = 0;
    Object.keys(score).forEach(function (k) { if (score[k] > max) { max = score[k]; best = k; } });
    return best;
  }

  /* Normalizace odpovědí: doplní efektivní cíl a vyčistí extra. */
  function normalizuj(config, answers) {
    var a = Object.assign({}, answers);
    if (a.goal === "nevim") a.goal = cilZeSymptomu(config, a.symptoms);
    a.extra = (a.extra || []).filter(function (x) { return x && x !== "ne"; });
    a.intensity = a.intensity || "standard";
    return a;
  }

  /* ---------- Dávkování ---------- */
  function davkaProTier(config, davKlic, intensity) {
    var d = config.davkovani[davKlic];
    if (!d) return null;
    return d.vse || d[intensity] || d.standard || null;
  }

  /* Denní dávka v jednotkách dané řady; null = nelze určit (→ bez vydatnosti). */
  function jednotekDenne(rada, davka) {
    if (!davka) return null;
    if (davka.jednotky != null) return davka.jednotky;
    if (davka.mg != null && rada && rada.mgMasticha) return Math.ceil(davka.mg / rada.mgMasticha);
    return null;
  }

  /* ---------- Vydatnost balení ----------
   * Položky: explicitní `polozky`, jinak {rada, jednotek} z balení samotného.
   * Hlavní řada se dávkuje podle pravidla; vedlejší podle denní dávky položky v protokolu
   * sady (`denne`), jinak podle vychoziDavka (běžné dávky) své řady.
   */
  function polozkyBaleni(b) {
    if (b.polozky && b.polozky.length) return b.polozky;
    if (b.jednotek != null) return [{ rada: b.rada, jednotek: b.jednotek }];
    return [];
  }

  function vydrzBaleni(catalog, config, b, hlavniRada, davka) {
    if (b.vydrzFixni != null) return b.vydrzFixni;
    var items = polozkyBaleni(b);
    if (!items.length) return null;
    var min = null;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var rada = catalog.rady[it.rada];
      var denne;
      if (it.rada === hlavniRada) denne = jednotekDenne(rada, davka);
      else {
        var defDavka = davkaProTier(config, config.radaDavkovani[it.rada], "standard");
        if (it.denne != null) denne = it.denne;
        else denne = (rada && rada.vychoziDavka != null) ? rada.vychoziDavka : jednotekDenne(rada, defDavka);
      }
      if (!denne || denne <= 0) return null;
      var dni = Math.floor(it.jednotek / denne);
      if (min === null || dni < min) min = dni;
    }
    return min;
  }

  /* ---------- Výběr balení v rámci řady ---------- */
  function spocitejMoznosti(catalog, config, radaKlic, davKlic, intensity) {
    var davka = davkaProTier(config, davKlic, intensity);
    var kuraDni = davka ? davka.kuraDni : null;
    var moznosti = catalog.baleni
      .filter(function (b) { return b.rada === radaKlic; })
      .map(function (b) {
        var vydrz = vydrzBaleni(catalog, config, b, radaKlic, davka);
        var pocet = (vydrz && kuraDni) ? Math.ceil(kuraDni / vydrz) : (vydrz ? 1 : null);
        return {
          baleni: b, vydrzDni: vydrz, pocetNaKuru: pocet,
          cenaCelkem: pocet != null ? pocet * b.cena : null,
          cenaNaDen: vydrz ? Math.round(b.cena / vydrz) : null
        };
      });
    return { davka: davka, kuraDni: kuraDni, moznosti: moznosti };
  }

  /* Nejlepší dostupné balení: nejnižší celková cena pokrývající kúru, ale v cenové
   * toleranci (výchozí +5 %) se preferuje méně balení – 1× Economy je lepší doporučení
   * než 5× malé balení o pár korun levněji. Průběžné užívání (bez délky kúry): nejnižší
   * cena za den (rozhodnutí 40). Bez vydatnosti: nejlevnější dostupné. */
  function vyberBaleni(moznosti, config, kuraDni) {
    var dostupne = moznosti.filter(function (m) { return m.baleni.dostupne; });
    if (!dostupne.length) return null;
    if (!kuraDni) {
      var naDen = dostupne.filter(function (m) { return m.cenaNaDen != null; });
      if (naDen.length) {
        naDen.sort(function (x, y) { return (x.cenaNaDen - y.cenaNaDen) || (x.baleni.cena - y.baleni.cena); });
        return naDen[0];
      }
    }
    var sVydatnosti = dostupne.filter(function (m) { return m.cenaCelkem != null; });
    if (sVydatnosti.length) {
      sVydatnosti.sort(function (x, y) {
        return (x.cenaCelkem - y.cenaCelkem) || (x.pocetNaKuru - y.pocetNaKuru);
      });
      var tolerance = 1 + (config && config.tolerancePoctuBaleni != null ? config.tolerancePoctuBaleni : 0.05);
      var strop = sVydatnosti[0].cenaCelkem * tolerance;
      var vTolerance = sVydatnosti.filter(function (m) { return m.cenaCelkem <= strop; });
      vTolerance.sort(function (x, y) {
        return (x.pocetNaKuru - y.pocetNaKuru) || (x.cenaCelkem - y.cenaCelkem);
      });
      return vTolerance[0];
    }
    dostupne.sort(function (x, y) { return x.baleni.cena - y.baleni.cena; });
    return dostupne[0];
  }

  /* ---------- Pravidla ---------- */
  function vyberPravidlo(config, a, trace) {
    if (config.strom) {
      var c = cestaStromem(config, a);
      if (trace) c.uzly.forEach(function (u) { trace.push({ id: u.id, splneno: true, podminky: [{ p: klicUzlu(u), ocekava: odpovediUzlu(u).map(function (o) { return o.v; }), hodnota: a[klicUzlu(u)], ok: true }] }); });
      if (!c.konec) return null;
      if (Array.isArray(c.konec.produkty)) return { id: c.konec.id, produkty: c.konec.produkty, dni: c.konec.dni || null };
      return { id: c.konec.id, rada: c.konec.rada, alt: c.konec.alt || null, dav: config.radaDavkovani[c.konec.rada], intenzita: c.konec.intenzita };
    }
    for (var i = 0; i < config.pravidla.length; i++) {
      var r = config.pravidla[i];
      var ok = splneno(r.kdyz, a);
      if (trace) {
        trace.push({
          id: r.id, splneno: ok,
          podminky: (r.kdyz || []).map(function (c) {
            return { p: c.p, ocekava: c.in || c.maNektery || c.v, hodnota: aktualniHodnota(c, a), ok: splnenaPodminka(c, a) };
          })
        });
      }
      if (ok) {
        return {
          id: r.id,
          rada: r.radaDle ? r.radaDle[a.intensity] : r.rada,
          alt: r.altDle ? r.altDle[a.intensity] : r.alt,
          dav: r.dav
        };
      }
    }
    return null;
  }

  function varovani(config, a) {
    var texty = [], lekar = false;
    config.bezpecnost.forEach(function (b) {
      if (splneno(b.kdyz, a)) { texty.push({ id: b.id, cs: b.cs }); if (b.lekar) lekar = true; }
    });
    return { texty: texty, lekar: lekar };
  }

  /* ---------- Kombinované kúry jako doplněk ----------
   * Řady v `config.kombinovaneKury` (sady více řad) se nabízejí k výsledku, když obsahují
   * primární řadu: od každé nejlevnější dostupné balení, seřazené podle ceny, s výdrží a cenou
   * za den (primární řada v dávce výsledku, ostatní v běžné dávce). */
  function radyVBaleni(b) {
    return polozkyBaleni(b).map(function (p) { return p.rada; });
  }
  function doplnkoveKury(catalog, config, primarni) {
    if (!primarni) return [];
    var vybraneId = primarni.vybrane ? primarni.vybrane.baleni.id : null;
    var out = [];
    (config.kombinovaneKury || []).forEach(function (radaKlic) {
      if (radaKlic === primarni.radaKlic || !catalog.rady[radaKlic]) return;
      var kandidati = catalog.baleni.filter(function (b) {
        return b.rada === radaKlic && b.dostupne && b.id !== vybraneId && radyVBaleni(b).indexOf(primarni.radaKlic) !== -1;
      });
      if (!kandidati.length) return;
      kandidati.sort(function (x, y) { return x.cena - y.cena; });
      var b = kandidati[0];
      var vydrz = vydrzBaleni(catalog, config, b, primarni.radaKlic, primarni.davka);
      out.push({ radaKlic: radaKlic, rada: catalog.rady[radaKlic], baleni: b, vydrzDni: vydrz, cenaNaDen: vydrz ? Math.round(b.cena / vydrz) : null });
    });
    out.sort(function (x, y) { return x.baleni.cena - y.baleni.cena; });
    return out;
  }

  /* ---------- Konec s produkty (rozhodnutí 43) ----------
   * Každý produkt konce: balení z katalogu podle SKU (chybí-li na storu, vypadne – sortiment se liší),
   * výdrž při denní dávce, při kúře počet balení na celou dobu (u balení s jedním obsahem přesně
   * z jednotek, u sad podle výdrže), cena celkem a cena za den (minor units). Pořadí z aplikace;
   * nejnizsiNaDen = index dostupného produktu s nejnižší cenou za den (nebo null). */
  function konecSProdukty(catalog, config, konec) {
    var dni = konec.dni || null;
    var produkty = [];
    (konec.produkty || []).forEach(function (x) {
      var b = (catalog.baleni || []).filter(function (bb) { return (bb.sku || bb.id) === x.sku; })[0];
      if (!b || !(x.davka > 0)) return;
      var vydrz = vydrzBaleni(catalog, config, b, b.rada, { jednotky: x.davka });
      var jednoduche = !(b.polozky && b.polozky.length) && b.vydrzFixni == null && b.jednotek > 0;
      var kusu = 1, cenaNaDen = null;
      if (dni) {
        kusu = jednoduche ? Math.ceil(x.davka * dni / b.jednotek) : (vydrz ? Math.ceil(dni / vydrz) : null);
        if (kusu != null) cenaNaDen = Math.round(kusu * b.cena / dni);
      } else if (jednoduche) cenaNaDen = Math.round(b.cena * x.davka / b.jednotek);
      else if (vydrz) cenaNaDen = Math.round(b.cena / vydrz);
      produkty.push({ baleni: b, davka: x.davka, vydrzDni: vydrz, kusu: kusu, cenaCelkem: kusu != null ? kusu * b.cena : null, cenaNaDen: cenaNaDen });
    });
    var nejnizsi = null;
    produkty.forEach(function (p, i) {
      if (!p.baleni.dostupne || p.cenaNaDen == null) return;
      if (nejnizsi === null || p.cenaNaDen < produkty[nejnizsi].cenaNaDen) nejnizsi = i;
    });
    return { id: konec.id, dni: dni, produkty: produkty, nejnizsiNaDen: nejnizsi };
  }

  /* ---------- Hlavní vstup ---------- */
  function doporuc(catalog, config, answers, opts) {
    var debug = !!(opts && opts.trace);
    var a = normalizuj(config, answers);
    var varov = varovani(config, a);
    var pravidlaLog = debug ? [] : null;
    var pravidlo = vyberPravidlo(config, a, pravidlaLog);
    /* U stromu dávku a délku kúry určuje konec (prevence / kúra), ne odpověď. */
    if (pravidlo && pravidlo.intenzita) a.intensity = pravidlo.intenzita;
    function trace(extra) {
      if (!debug) return undefined;
      return Object.assign({
        vstup: answers,
        odpovedi: a,
        cilZeSymptomu: (answers && answers.goal === "nevim") ? a.goal : null,
        pravidla: pravidlaLog,
        diagnostika: diagnostikaKatalogu(catalog, config)
      }, extra || {});
    }
    if (!pravidlo) return { chyba: "zadne_pravidlo", varovani: varov.texty, lekar: varov.lekar, trace: trace() };
    if (pravidlo.produkty) {
      var konec = konecSProdukty(catalog, config, pravidlo);
      return {
        odpovedi: a, pravidloId: pravidlo.id, lekar: varov.lekar, varovani: varov.texty,
        konec: konec, primarni: null, fallbackPouzit: false, alternativa: null, tipy: [], doplnky: [],
        vyprodanoVse: !konec.produkty.some(function (p) { return p.baleni.dostupne; }),
        trace: trace({ pravidlo: { id: pravidlo.id, produkty: pravidlo.produkty, dni: pravidlo.dni } })
      };
    }

    /* Primární řada; při nedostupnosti všech balení fallback na alternativu. */
    function slozDoporuceni(radaKlic, davKlic) {
      var rada = catalog.rady[radaKlic];
      if (!rada) return null;
      var vypocet = spocitejMoznosti(catalog, config, radaKlic, davKlic, a.intensity);
      return {
        rada: rada, radaKlic: radaKlic,
        davka: vypocet.davka, kuraDni: vypocet.kuraDni,
        moznosti: vypocet.moznosti,
        vybrane: vyberBaleni(vypocet.moznosti, config, vypocet.kuraDni)
      };
    }

    var primarni = slozDoporuceni(pravidlo.rada, pravidlo.dav);
    var fallbackPouzit = false;
    if (!primarni || !primarni.vybrane) {
      var nahradni = pravidlo.alt && slozDoporuceni(pravidlo.alt, config.radaDavkovani[pravidlo.alt] || pravidlo.dav);
      if (nahradni && nahradni.vybrane) { primarni = nahradni; fallbackPouzit = true; }
    }
    var alternativa = null;
    if (!fallbackPouzit && pravidlo.alt && pravidlo.alt !== (primarni && primarni.radaKlic)) {
      alternativa = slozDoporuceni(pravidlo.alt, config.radaDavkovani[pravidlo.alt] || pravidlo.dav);
    }

    /* Doplňkové tipy: vedlejší cíle, které primární řada (vč. obsahu vybraného balení) nepokrývá. */
    var pokryto = [];
    if (primarni) {
      pokryto.push(primarni.radaKlic);
      if (primarni.vybrane) pokryto = pokryto.concat(radyVBaleni(primarni.vybrane.baleni));
    }
    var tipy = [];
    a.extra.forEach(function (cil) {
      var tipRada = config.tipy[cil];
      if (tipRada && pokryto.indexOf(tipRada) === -1 && pravidlo.rada !== tipRada && catalog.rady[tipRada]) {
        if (tipy.indexOf(tipRada) === -1) tipy.push(tipRada);
      }
    });

    return {
      odpovedi: a,
      pravidloId: pravidlo.id,
      lekar: varov.lekar,
      varovani: varov.texty,
      primarni: primarni,
      fallbackPouzit: fallbackPouzit,
      alternativa: alternativa,
      tipy: tipy.map(function (k) { return { radaKlic: k, rada: catalog.rady[k] }; }),
      doplnky: doplnkoveKury(catalog, config, primarni),
      vyprodanoVse: !primarni || !primarni.vybrane,
      trace: trace({ pravidlo: { id: pravidlo.id, rada: pravidlo.rada, alt: pravidlo.alt, dav: pravidlo.dav } })
    };
  }

  /* ---------- Diagnostika katalogu (debug) ----------
   * Najde konfigurační chyby, kvůli kterým engine tiše nevybere produkt:
   * chybějící řady odkazované pravidly/tipy, balení bez spočitatelné vydatnosti
   * (přeskočí se ve výběru), balení bez varianty, řady bez balení.
   */
  function diagnostikaKatalogu(catalog, config) {
    var problemy = [];
    function pridej(uroven, kod, zprava) { problemy.push({ uroven: uroven, kod: kod, zprava: zprava }); }
    if (!catalog || !catalog.rady) return problemy;

    /* Řady odkazované v pravidlech a tipech musí být v katalogu. */
    var odkazovane = {};
    if (config.strom) Object.keys(config.strom.uzly).forEach(function (id) {
      var u = config.strom.uzly[id];
      if (u.konec) [u.rada, u.alt].forEach(function (k) { if (k) odkazovane[k] = true; });
      if (u.konec && Array.isArray(u.produkty)) u.produkty.forEach(function (x) {
        if (!(catalog.baleni || []).some(function (b) { return (b.sku || b.id) === x.sku; })) pridej("info", "konec_sku_chybi", 'Konec "' + id + '": produkt ' + x.sku + " v katalogu storu není – vynechá se.");
      });
    });
    (config.pravidla || []).forEach(function (r) {
      [r.rada, r.alt].forEach(function (k) { if (k) odkazovane[k] = true; });
      [r.radaDle, r.altDle].forEach(function (m) { if (m) Object.keys(m).forEach(function (kk) { odkazovane[m[kk]] = true; }); });
    });
    Object.keys(config.tipy || {}).forEach(function (c) { odkazovane[config.tipy[c]] = true; });
    Object.keys(odkazovane).forEach(function (k) {
      if (!catalog.rady[k]) pridej("chyba", "rada_chybi", 'Řada "' + k + '" je v pravidlech/tipech, ale v katalogové kolekci není produkt s tímto rada_klic.');
    });

    /* Balení: odkazované řady, spočitatelná vydatnost, varianta, dostupnost. */
    var radyVKatalogu = {};
    (catalog.baleni || []).forEach(function (b) {
      var jmeno = b.nazev || b.id;
      polozkyBaleni(b).forEach(function (it) {
        radyVKatalogu[it.rada] = true;
        if (!catalog.rady[it.rada]) pridej("chyba", "baleni_rada_chybi", 'Balení "' + jmeno + '" odkazuje řadu "' + it.rada + '", která není v katalogu.');
      });
      var davka = davkaProTier(config, config.radaDavkovani[b.rada], "standard");
      if (vydrzBaleni(catalog, config, b, b.rada, davka) == null) {
        pridej("varovani", "baleni_bez_vydatnosti", 'Balení "' + jmeno + '" (řada ' + b.rada + '): nelze určit vydatnost → ve výsledku se přeskočí. Zkontrolujte jednotky / mg / složení řady.');
      }
      if (b.variantId == null) pridej("varovani", "baleni_bez_varianty", 'Balení "' + jmeno + '" nemá variantId → nepůjde přidat do košíku.');
      if (!b.dostupne) pridej("info", "baleni_vyprodano", 'Balení "' + jmeno + '" je nedostupné (dostupne=false).');
    });

    /* Řady bez jediného balení. */
    Object.keys(catalog.rady).forEach(function (k) {
      if (!radyVKatalogu[k]) pridej("varovani", "rada_bez_baleni", 'Řada "' + k + '" nemá v katalogu žádné balení.');
    });

    return problemy;
  }

  /* ---------- Formát textů (komentář volby, text konce) ----------
   * Omezený markdown, nikdy HTML: text se nejdřív escapuje, pak **tučně**, *kurzíva*, řádek začínající
   * „- “ nebo „• “ = odrážka, prázdný řádek = nový odstavec, jinak nový řádek. Odkazy [text](https://…)
   * jen mimo tlačítko (opts.vTlacitku: jen span, bez odkazů – tlačítko nesmí obsahovat blok ani odkaz). */
  function escText(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }
  function formatRadku(s, odkazy) {
    var h = escText(s)
      .replace(/\*\*(\S(?:.*?\S)?)\*\*/g, "<strong>$1</strong>")
      .replace(/(^|[^*])\*(\S(?:.*?\S)?)\*(?!\*)/g, "$1<em>$2</em>");
    return h.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]*)\)/g, odkazy ? '<a href="$2">$1</a>' : "$1");
  }
  function formatujText(text, opts) {
    var vTlacitku = !!(opts && opts.vTlacitku);
    var tag = vTlacitku ? { p: '<span class="mlk-md-p">', pz: "</span>", ul: '<span class="mlk-md-ul">', ulz: "</span>", li: '<span class="mlk-md-li">', liz: "</span>" }
      : { p: "<p>", pz: "</p>", ul: "<ul>", ulz: "</ul>", li: "<li>", liz: "</li>" };
    var bloky = [], odstavec = [], seznam = [];
    function zavri() {
      if (odstavec.length) bloky.push(tag.p + odstavec.map(function (r) { return formatRadku(r, !vTlacitku); }).join("<br>") + tag.pz);
      if (seznam.length) bloky.push(tag.ul + seznam.map(function (r) { return tag.li + formatRadku(r, !vTlacitku) + tag.liz; }).join("") + tag.ulz);
      odstavec = []; seznam = [];
    }
    String(text == null ? "" : text).replace(/\r/g, "").split("\n").forEach(function (r) {
      var m = /^\s*[-•]\s+(.*)$/.exec(r);
      if (m) { if (odstavec.length) zavri(); seznam.push(m[1]); }
      else if (!r.trim()) zavri();
      else { if (seznam.length) zavri(); odstavec.push(r.trim()); }
    });
    zavri();
    return bloky.join("");
  }

  var MLK_ENGINE = {
    formatujText: formatujText,
    doporuc: doporuc,
    aktivniKroky: aktivniKroky,
    celkemKroku: celkemKroku,
    cestaStromem: cestaStromem,
    aktivniVolby: aktivniVolby,
    cilZeSymptomu: cilZeSymptomu,
    diagnostikaKatalogu: diagnostikaKatalogu,
    vychoziOdpovedi: vychoziOdpovedi,
    sanitizujOdpovedi: sanitizujOdpovedi,
    /* exporty pro testy */
    konecSProdukty: konecSProdukty,
    _internal: { splneno: splneno, vydrzBaleni: vydrzBaleni, spocitejMoznosti: spocitejMoznosti, vyberBaleni: vyberBaleni, normalizuj: normalizuj }
  };

  if (typeof module !== "undefined" && module.exports) module.exports = MLK_ENGINE;
  else root.MLK_ENGINE = MLK_ENGINE;
})(typeof window !== "undefined" ? window : globalThis);
